import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "mn_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const admin = axios.create({ baseURL: API });
admin.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Auth
export const adminLogin = (email, password) =>
  admin.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => admin.get("/auth/me").then((r) => r.data);
export const adminChangePassword = (current_password, new_password) =>
  admin.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);

// Stats
export const adminStats = () => admin.get("/admin/stats").then((r) => r.data);

// Products
export const adminGetProducts = () => admin.get("/admin/products").then((r) => r.data);
export const adminCreateProduct = (p) => admin.post("/admin/products", p).then((r) => r.data);
export const adminUpdateProduct = (id, p) => admin.put(`/admin/products/${id}`, p).then((r) => r.data);
export const adminDeleteProduct = (id) => admin.delete(`/admin/products/${id}`).then((r) => r.data);

// Upload
export const adminUpload = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return admin.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// Settings
export const adminGetSettings = () => admin.get("/settings").then((r) => r.data);
export const adminUpdateSettings = (s) => admin.put("/admin/settings", s).then((r) => r.data);

// Promo codes
export const adminGetPromos = () => admin.get("/admin/promo-codes").then((r) => r.data);
export const adminCreatePromo = (p) => admin.post("/admin/promo-codes", p).then((r) => r.data);
export const adminUpdatePromo = (id, p) => admin.put(`/admin/promo-codes/${id}`, p).then((r) => r.data);
export const adminDeletePromo = (id) => admin.delete(`/admin/promo-codes/${id}`).then((r) => r.data);

// Blog
export const adminGetBlog = () => admin.get("/admin/blog").then((r) => r.data);
export const adminCreateBlog = (b) => admin.post("/admin/blog", b).then((r) => r.data);
export const adminUpdateBlog = (slug, b) => admin.put(`/admin/blog/${slug}`, b).then((r) => r.data);
export const adminDeleteBlog = (slug) => admin.delete(`/admin/blog/${slug}`).then((r) => r.data);

// Orders / messages
export const adminGetOrders = () => admin.get("/admin/orders").then((r) => r.data);
export const adminUpdateOrderStatus = (orderId, payload) =>
  admin.put(`/admin/orders/${orderId}/status`, payload).then((r) => r.data);
export const adminGetContacts = () => admin.get("/admin/contacts").then((r) => r.data);
export const adminGetNewsletter = () => admin.get("/admin/newsletter").then((r) => r.data);
export const adminGetStockRequests = () => admin.get("/admin/stock-requests").then((r) => r.data);

export default admin;
